import { Grid } from '@material-ui/core';
import { Select, Button, Tooltip, Icon } from 'antd';
import TextEvents from 'app/components/TextEvents';
//import { ListadoKeyUserReducer } from 'app/reducers/ListadoKeyUserReducer';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styles, useStyles } from '../KuCatalogueScreenStyles';
//import * as ListadoKeyUserActions from "app/actions/ListadoKeyUserActions";
import * as KUCatalogueActions from 'app/actions/KUCatalogueActions'
import { employeeById } from 'app/reducers';
import { KUCatalogueReducer } from 'app/reducers/KUCatalogueReducer';

const FilterScreen = (props) => {
    const classes = useStyles();
    const [names, setNames] = useState([]);
    const [collapse, setCollapse] = useState(true);
    const [keyuser, setKeyuser] = useState([]);
    const dispatch = useDispatch();
    const { siteId } = useSelector(state => state.Auth)
    const employeeData = useSelector(employeeById);

    // const {
    //     filter,
    //     isLoadingFilters,
    // } = useSelector(state => state.ListadoKeyUserReducer);


    const { listAllKeyUser,
        isLoadingAllKeyUser,
        pagination,
        isExportingKeyUser
    } = useSelector(state => state.KUCatalogueReducer)

    const data = {
        SystemName: names,
        KuName: keyuser
    }


    const onSelectNames = (names) => {
        setNames(names);
    }

    const onSelectKeyUser = (keyuser) => {
        setKeyuser(keyuser);
    }

    // const onSelectFunctional = (functional) => {
    //     props.setFiltroFuncional(functional);
    // }



    const search = () => {
        dispatch(KUCatalogueActions.getKeyUsers({
            offset: 0,
            limit: pagination.pageSize,
            sortDir: "asc",
            sortColumn: "name",
            Name: "",
            IdEmployee: keyuser 
        }));
    }

    const exportXls = () => {
        dispatch(KUCatalogueActions.exportXls({
            offset: (pagination.current - 1) * pagination.pageSize,
            limit: pagination.pageSize,
            sortDir: pagination.order,
            sortColumn: pagination.column,
            Name: "",
            IdEmployee: keyuser 
        }))
    }

    const optionsNames = <Select.Option key={0} value={0}>Sin registros</Select.Option>

    // filter.listSystems.map((item) =>
    //     <Select.Option key={item} value={item}>{item}</Select.Option>
    // );

    const optionsKeyUsers = listAllKeyUser.map((item) =>
        <Select.Option key={item.idEmployee} value={item.idEmployee}>{item.name}</Select.Option>
    );



    return (
        <div>
            <div hidden={collapse}>
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={6} >
                        <TextEvents
                            text='Nombre:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            loading={false}
                            placeholder="[Selecionar Nombre]"
                            showSearch
                            value={keyuser}
                            onChange={onSelectKeyUser}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {optionsKeyUsers}
                        </Select>
                    </Grid>
                </Grid>
            </div>
            {/**Botones */}
            <div className={classes.container} style={styles.baseVerticalMargin}>
                {
                    collapse ?
                        <Tooltip title={"Mostrar filtro"}>
                            <Button
                                className={classes.button}
                                variant="contained"
                                type="link"
                                onClick={() => setCollapse(false)}
                            >
                                <Icon type="down" />
                            </Button>
                        </Tooltip> :
                        <Tooltip title={"Ocultar filtro"}>
                            <Button
                                className={classes.button}
                                variant="contained"
                                type="link"
                                onClick={() => setCollapse(true)}
                            >
                                <Icon type="up" />
                            </Button>
                        </Tooltip>
                }
                {
                    siteId === 'HUB' ?
                        <Button
                            className={classes.button}
                            variant="contained"
                            type="primary"
                            onClick={() => props.setVisibleModal(true)}
                        >
                            Nuevo
                        </Button> : null
                }

                <Button
                    className={classes.button}
                    variant="contained"
                    type="primary"
                    loading={isLoadingAllKeyUser}
                    onClick={() => search()}
                >
                    Buscar
                </Button>
                <Button
                    className={classes.button}
                    variant="contained"
                    type="primary"
                    loading={isExportingKeyUser}
                    onClick={() => exportXls()}
                >
                    Exportar
                </Button>
            </div>
        </div>
    );
}

export default FilterScreen;
